module.exports = __webpack_public_path__ + "img/Simulation-Column.2035378b.jpeg";